import moment from "moment";

function ImageEditor(value, edit, attributes) {
  return edit ? (
    <input type="text" {...attributes} value={value}></input>
  ) : value ? (
    <img
      src={value?.toString()}
      className="img-thumbnail image-editor"
      style={{ maxHeight: "6rem", cursor: "pointer" }}
      onClick={() => {
        window["primaryModal"].setState({
          show: true,
          title: value.toString(),
          size: "default",
          body: (
            <div>
              <img src={value?.toString()} className="img-fluid"></img>
            </div>
          ),
        });
      }}
    ></img>
  ) : (
    ""
  );
}

export default ImageEditor;
